import React from "react";
import HeaderOne from "../components/header/HeaderOne";
import Breadcrumb from "./Breadcrumb";
import ServiceTen from "../components/about/AboutHistory";
import FaqTwo from "../components/faq/FaqTwo";
import PricingThree from "../components/pricing/PricingThree";

import FooterOne from "../components/footer/FooterOne";

function OurService() {
  const breadcrumbs = [
    { label: "Ana Sayfa", link: "/" },
    { label: "Tarihsel Gelişim" },
  ];
  return (
    <div className="">
      <HeaderOne />
      <Breadcrumb title="Tarihsel Gelişim" breadcrumbs={breadcrumbs} />
      <ServiceTen />

      <FooterOne />
    </div>
  );
}

export default OurService;
